<template>
  <div>
    <v-card class="mb-2 elevation-1">
      <v-card-title class="pa-0">
        <v-list two-line>
          <v-list-tile avatar>
            <v-list-tile-avatar>
              <v-icon class="grey white--text">folder</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.label }}</v-list-tile-title>
              <v-list-tile-sub-title>{{ item.name }}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-card-title>
      <v-card-text>
        <div class="mb-2 font-weight-bold">Design:</div>
        <base-info
          v-if="item.minumumText != null"
          :item="item.minumumText"
          color="green"
          class="ml-2"
        ></base-info>
        <base-info
          v-if="item.totalSpaceList != null"
          :item="item.totalSpaceList"
          color="green"
          class="ml-2"
        ></base-info>
      </v-card-text>
      <v-card-text v-if="item.suitability != null" class="pt-0">
        <div class="mb-2 font-weight-bold">Suitability:</div>
        <base-info
          :item="item.suitability"
          color="cyan"
          class="ml-2"
        ></base-info>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  props: ["item"]
};
</script>

<style>
.information {
  border-radius: 8px;
  margin-bottom: 16px;
  position: relative;
  display: block;
}
.information-border {
  border-style: solid;
  border-width: 3px;
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  border-top-left-radius: inherit;
  border-bottom-left-radius: inherit;
  top: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/base/Card.vue